<template>
  <div class="content">
    <div class="page-inner">
      <div class="card">
        <div class="card-body">
          <h1>{{ $t('credits').toUpperCase() }}</h1>
          <div class="card-subtitle mb-3">
            <span class="text-muted">{{ $t('credits_page_subtitle') }}</span>
            <span class="pull-right">{{ $t('current_credits') }} <span class="text-warning h2">{{ credits }}</span></span>
          </div>
        </div>
      </div>
      <div class="mb-4">
        <span class="strong">{{ $t('select_credit_plan') }}</span>
      </div>
      <div class="row mb-4">
        <div class="col-6 col-sm-6 col-md-3 text-center mb-3" v-for="(button, index) in buttons" v-bind:key="index" @click="setPaypalButton(index)">
          <div class="btn text-center w-100 box-shadow" :class="{ 'btn-primary strong text-white': index === activeButton, 'bg-light text-dark': index != activeButton }">
            <div>
            <span class="icon-big strong text-big">{{ button.credits }}</span>
            </div>
            <div>
              <span class="icon-big h1 fw-light">{{ $t('credits')}}</span>
            </div>
            <div class="my-2 h2">
              <i class="fas fa-money-bill-alt"></i>
            </div>
            <hr>
            <div class="my-5">
              <span class="h2">${{ button.cost }} USD</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3 m-auto" v-for="(button, index) in buttons" v-bind:key="index">
        <div :id="'paypal_' + index" class="mt-4" v-show="activeButton === index"></div>
      </div>
    </div>
  </div>
</template>
<script>

import _ from 'lodash'

export default {
  data: function () {
    return {
      credits: 0,
      user: {},
      buttons: [
        { credits: 75, cost: 4.99, cost_mxn: 99 },
        { credits: 150, cost: 9.99, cost_mxn: 199 },
        { credits: 300, cost: 19.99, cost_mxn: 349 },
        { credits: 1000, cost: 59.99, cost_mxn: 1149, offer: true }
      ],
      activeButton: null
    }
  },
  methods: {
    purchaseSuccess (result) {
      if (result.transactions) {
        this.$notify({ message: this.$t('credits_added') }, 'success', 'fa-check')
        this.$http.post(`${window.apiURL}api/user/credits`, result, { withCredentials: true }).then(response => {
          this.$eventBus.$emit('updateCredits')
        }, (response) => {
          console.error('Error on purchase', response)
        })
      }
    },
    renderPaypalButtons () {
      let environment = 'production'
      let lang = 'en_US'

      if (location.host.match(/localhost|development|staging/)) {
        environment = 'sandbox'
      }

      if (window.navigator.language.match(/es/)) {
        lang = 'es_ES'
      }

      _.each(this.buttons, (button, index) => {
        paypal.Button.render({
          env: environment, // Or 'production or sandbox',
          client: {
            production: 'Ac4lOtfFJuDY-dNuAJE4enid-k0VMlZT3lrWq2YbziGfh80MGP9TH2obduq_OuRPuNHnx0WVJPupUP1q',
            sandbox: 'AawfM9czZeZD6nUgcj_ycXFuZCRQSBdKMuQd-1Sxd5kKYhd0FfkKSdJx_mggQr7rB1wOV_NFghulJ0ME'
          },
          locale: lang,
          style: {
            color: 'blue',
            fundingicons: 'true',
            shape: 'rect',
            size: 'responsive'
          },
          payment: (data, actions) => {
            return actions.payment.create({
              transactions: [{
                custom: _.find(this.buttons, (button, _index) => _index === index).credits,
                amount: {
                  total: button.cost,
                  currency: 'USD'
                }
              }]
            })
          },
          onAuthorize: (data, actions) => {
            return actions.payment.execute()
              .then(response => this.purchaseSuccess(response))
          },
          onCancel: (data, actions) => {
            // return actions.redirect()
          },
          onError: (error) => {
            console.error('Paypal not success purchase', error)
          }
        }, '#paypal_' + index)
      })
    },
    setPaypalButton (index) {
      this.activeButton = index
    }
  },
  created () {
    this.$http.get(`${window.apiURL}api/user/credits`, { withCredentials: true }).then(response => {
      this.credits = response.data.available || 0
    })

    this.$eventBus.$on('creditsUpdated', (data) => {
      this.credits = data.credits
    })

    let user = localStorage.getItem('user')

    if (user) {
      try {
        this.user = JSON.parse(user)
      } catch (e) {}
    }
  },
  mounted () {
    this.renderPaypalButtons()
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Credits.vue